var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 11C7.30284 11 7.10572 10.928 6.95542 10.7842L2.22566 6.25832C1.92478 5.97041 1.92478 5.50363 2.22566 5.21584C2.52641 4.92805 3.01413 4.92805 3.31503 5.21584L7.49998 9.22061L11.685 5.21598C11.9858 4.92819 12.4735 4.92819 12.7742 5.21598C13.0753 5.50377 13.0753 5.97055 12.7742 6.25846L8.04455 10.7844C7.89417 10.9281 7.69705 11 7.49998 11Z",
    fill: "#157FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.f3f5c7cf792ebc9c99462d750d1e963f.svg";
export { ForwardRef as ReactComponent };